var SENTRY_RELEASE;SENTRY_RELEASE={name: "Open Studio", version: "1.4.4"};